module.exports = __webpack_public_path__ + "img/section1Swiper4.b7e237f7.png";